const TestimonialsSection = () => {
  const testimonials = [
    {
      text: 'Lovely salon and fantastic service. Always leave feeling confident.',
      name: 'Emily T.',
      location: 'Otley',
      rating: 5,
    },
    {
      text: 'Amazing colour results every time. Sarah really listens and delivers exactly what I want.',
      name: 'Rachel M.',
      location: 'Otley',
      rating: 5,
    },
  ];

  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-sage/10 rounded-full mb-4">
            <span className="text-xs uppercase tracking-wider text-sage font-sans font-medium">
              Client Love
            </span>
          </div>
          <h2 className="text-5xl font-bold text-charcoal font-serif">
            What Our Clients Say
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-charcoal rounded-[32px] p-12 relative"
            >
              <div className="text-cream text-6xl font-serif mb-6">"</div>

              <p className="text-xl text-white font-sans leading-relaxed mb-8">
                {testimonial.text}
              </p>

              <div className="flex gap-1 mb-5">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>

              <div>
                <p className="text-white font-sans font-semibold">
                  {testimonial.name}
                </p>
                <p className="text-gray-400 text-sm font-sans mt-1">
                  {testimonial.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;